import CommonModal from "../../../App/commonModal"
import React, { useRef, useState } from "react";
import { Context,Hooks,Util,Request } from "@xt/xtbase";
import {post_addInviteCode} from "@/api/referral";
import { Slider } from "antd";

const {useTranslation, useDocumentWidth} = Hooks;
const {getOrigin, getUrl} = Util;

function AddInviteCodeModal (props) {
  const { isShowModal, onClose, getInviteCodeList } = props;
  const t = useTranslation();
  const lastVibrateAtRef = useRef(0);

  const [value, setValue] = useState(40)

  const triggerVibrate = () => {
    if (typeof window === "undefined") return;
    const { navigator } = window;
    if (!navigator || typeof navigator.vibrate !== "function") return;
    const now = Date.now();
    if (now - lastVibrateAtRef.current < 80) return;
    lastVibrateAtRef.current = now;
    navigator.vibrate(10);
  };

  const onChange = (value) => {
    console.log('onChange: ', value);
    triggerVibrate();
    setValue(value)
  };

  const onSave = () => {
    post_addInviteCode({
      successPop: true,
      data:{selfCommissionRate: value / 100}
    }).then((result)=>{
      getInviteCodeList()
      onClose()
    })
  };

  return (
    <CommonModal width={420} title={t("home.addRecommended")} isShowModal={isShowModal} onClose={onClose} closable={false}>
      <div className="AddInviteCodeModal">
        <div className="tuijian">
          {t("console.link.setEarnBili")}
        </div>
        <div>
          <Slider defaultValue={40} className="referral-slider" tooltip={{ formatter: null }} onChange={onChange}
            marks={{
              0: '0',
              20: '20',
              40: '40',
              60: '60',
              80: '80',
              100: '100',
            }}
          />
        </div>
        <div className="bili">
          <div className="my">{t("console.manage.my")}<span>{value}%</span></div>
          <div className="you">{t("console.manage.friend")}<span>{100 - value}%</span></div>
        </div>
        <div className="foot1">
          <div className="cancel" onClick={onClose}>{t("home.cancel")}</div>
          <div className="save" onClick={onSave}>{t("home.save")}</div>
        </div>
      </div>
    </CommonModal>
  )

}

export default AddInviteCodeModal
